require('./recoverVm.style.scss');

let VERSION_TITLE = 'Restore Options',
    OPTIONS_STATE = 'vm_options',
    PICK_STATE = 'vm_pick',
    NETWORK_STATE = 'vm_network',
    DISK_SELECT_STATE = 'disk_select',
    CLONE_VM_PICK_STATE = 'CLONE',
    PARTIAL_RESTORE_PICK_STATE = 'PARTIAL_RESTORE',
    RESTORE_DISK_PICK_STATE = 'RESTORE_DISKS',
    CLONE_DISK_PICK_STATE = 'CLONE_DISKS',
    EXPORT_DISK_PICK_STATE = 'EXPORT_DISKS';

const tiers = [
    { tier: 'SNAPSHOT', label: 'Backup (SNAPSHOT)', targetType: 'SNAPSHOT' },
    { tier: 'BACKUP', label: 'Backup (TARGET)', targetType: 'TARGET' },
    { tier: 'COPY', label: 'Copy', targetType: 'TARGET' },
    { tier: 'ARCHIVE_DAILY', label: 'Archive - daily', targetType: 'TARGET' },
    { tier: 'ARCHIVE_WEEKLY', label: 'Archive - weekly', targetType: 'TARGET' },
    { tier: 'ARCHIVE_MONTHLY', label: 'Archive - monthly', targetType: 'TARGET' },
    { tier: 'ARCHIVE_YEARLY', label: 'Archive - yearly', targetType: 'TARGET' },
];

class RecoverVmController {
    constructor(
        $scope,
        $timeout,
        $q,
        $element,
        $filter,
        virtualMachinesPersistence,
        notificationService,
        utilsService,
        dialogService,
        sharedPersistenceService,
        contentSwitcherService,
        validationsService
    ) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$filter = $filter;
        this.$q = $q;
        this.persistence = virtualMachinesPersistence;
        this.sharedPersistence = sharedPersistenceService;
        this.notificationService = notificationService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.utilsService = utilsService;
        this.dialogService = dialogService;
        this.vmNamePattern = this.validationsService.getNewvmNamePattern();
        this.isRestoreValid = false;
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';
        this.contentSwitcherService = contentSwitcherService;
        this.filteredTiers = [];

        this.modalTitle = VERSION_TITLE;
        this.state = OPTIONS_STATE;
        this.pickCloneVirtualMachine = [
            {
                name: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.partial.title'),
                label: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.partial.description'),
                value: PARTIAL_RESTORE_PICK_STATE,
                isDisabled: () => !this.isBootDiskPresent,
            },
            {
                name: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.clone.title'),
                label: this.$filter('translate')('vm.restore.options.cloneRestore.description'),
                value: CLONE_VM_PICK_STATE,
                isDisabled: () => !this.isBootDiskPresent,
            },
            {
                name: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskRestore.title'),
                label: this.$filter('translate')('vm.restore.options.diskRestore.description'),
                value: RESTORE_DISK_PICK_STATE,
            },
            {
                name: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskClone.title'),
                label: this.$filter('translate')('vm.restore.options.diskClone.description'),
                value: CLONE_DISK_PICK_STATE,
            },
            {
                name: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskExport.title'),
                label: this.$filter('translate')('vm.restore.options.diskExport.description'),
                value: EXPORT_DISK_PICK_STATE,
            },
        ];
        // this.pickPartialRestore = [{
        //     name: this.$filter('translate')('vm.restore.options.restoreVirtualMachine.partial.description'),
        //     value: PARTIAL_RESTORE_PICK_STATE
        // }];
        this.initValues();
        this.setHelpId();
        this.configTable();
    }

    $onInit() {
        this.actionButton = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => {
                    this.onBackAction();
                    this.virtualNetworkStateFlag = false;
                    this.setHelpId();
                },
                isVisible: () =>
                    (this.state === PICK_STATE && this.pick) ||
                    this.state === NETWORK_STATE ||
                    this.state === DISK_SELECT_STATE,
                id: 'recover-vm-back',
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.validate'),
                action: () => {
                    this.validateRestore();
                },
                isDisabled: () =>
                    (this.dialogForm && !this.dialogForm.$valid) ||
                    (this.pick === CLONE_VM_PICK_STATE && (!this.virtualNetworks || this.virtualNetworks.length === 0)),
                isVisible: () =>
                    this.state === PICK_STATE &&
                    (this.pick === 'CLONE' || this.pick === 'PARTIAL_RESTORE' || this.isDisksPickState()),
                id: 'recover-vm-validate',
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.title'),
                action: () => this.restore(),
                isDisabled: () =>
                    (this.dialogForm && !this.dialogForm.$valid) ||
                    (this.pick === CLONE_VM_PICK_STATE &&
                        (!this.virtualNetworks || this.virtualNetworks.length === 0)) ||
                    !this.isRestoreValid,
                isVisible: () =>
                    this.state === PICK_STATE &&
                    (this.pick === 'CLONE' || this.pick === 'PARTIAL_RESTORE' || this.isDisksPickState()),
                id: 'recover-vm-restore',
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.next'),
                action: () => this.onNextAction(),
                isVisible: () => (this.state === OPTIONS_STATE || this.state === DISK_SELECT_STATE) && this.pick,
                isDisabled: () => this.isNextDisabled(),
                id: 'recover-vm-next',
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.save'),
                action: () => this.saveVirtualNetwork(),
                type: 'submit',
                isVisible: () => this.state === NETWORK_STATE && this.virtualNetworkEditFlag,
                id: 'recover-vm-save',
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.add'),
                action: () => this.saveVirtualNetwork(),
                type: 'submit',
                isVisible: () => this.state === NETWORK_STATE && !this.virtualNetworkEditFlag,
                id: 'recover-vm-add',
            },
        ];
        this.virtualNetworkTableConfig = [
            {
                name: this.$filter('translate')('ec.deploy.network.table.targetNetwork'),
                key: 'parentValue',
                isNetwork: true,
            },
            { name: this.$filter('translate')('ec.deploy.network.table.type'), key: 'value' },
        ];
        this.virtualNetworkTableActionButtons = [
            {
                title: this.$filter('translate')('common.action.delete'),
                icon: 'icon-trash',
                action: this.removeNetwork.bind(this),
            },
            {
                title: this.$filter('translate')('toolbar.default.edit.label'),
                icon: 'icon-edit',
                action: this.editNetwork.bind(this),
            },
        ];
    }

    initValues() {
        this.availableSubscriptions = [];
        this.availableDisks = [];
        this.availableZones = [];
        this.availableLocations = [];
        this.availableVirtualNetworks = [];
        this.allAvailabilityZone = [];
        this.availabilityZoneSearch = {};
        this.disksForRestore = [];
        this.selectedDisksForRestore = [];
        this.newvmName = '';
        this.virtualNetwork = '';
        this.oneLetter = false;
        this.maxNumTags = 0;
    }

    setHelpId() {
        this.helpId = 'VM-restore-options';
        if ((this.state = PICK_STATE && this.pick === CLONE_VM_PICK_STATE)) {
            this.helpId = 'VM-clone';
        }
        if ((this.state = PICK_STATE && this.pick === PARTIAL_RESTORE_PICK_STATE)) {
            this.helpId = 'VM-restore';
        }
        if ((this.state = PICK_STATE && this.pick === CLONE_DISK_PICK_STATE)) {
            this.helpId = 'disks-clone';
        }
        if ((this.state = PICK_STATE && this.pick === EXPORT_DISK_PICK_STATE)) {
            this.helpId = 'disks-export';
        }
        if ((this.state = PICK_STATE && this.pick === RESTORE_DISK_PICK_STATE)) {
            this.helpId = 'disks-restore';
        }
    }

    setPickRestoreLabels() {
        this.pickRestoreLabel = '';
        if (this.pick === CLONE_DISK_PICK_STATE) {
            this.pickRestoreLabel = this.$filter('translate')('vm.restore.options.cloneDisks.choose');
        }
        if (this.pick === RESTORE_DISK_PICK_STATE) {
            this.pickRestoreLabel = this.$filter('translate')('vm.restore.options.restoreDisks.choose');
        }
        if (this.pick === EXPORT_DISK_PICK_STATE) {
            this.pickRestoreLabel = this.$filter('translate')('vm.restore.options.exportDisks.choose');
        }
    }

    onNextAction() {
        this.newDisksNamesArray();
        this.disks = [];
        this.newvmName = '';
        this.virtualNetwork = '';
        this.availableDisks = [];
        if (this.isDisksPickState() && this.state !== DISK_SELECT_STATE) {
            this.changeState(DISK_SELECT_STATE);
            this.setPickRestoreLabels();
        } else {
            this.recoverOptions.push({
                id: 0,
                label: 'Automatic',
                value: null,
                selected: true,
            });

            for (let i = 0; i < this.selectedVersion.backupTiers.length; i++) {
                let filteredTiers = tiers.filter(
                    (item) =>
                        this.selectedVersion.backupTiers[i].targetType === item.targetType &&
                        this.selectedVersion.backupTiers[i].backupType === item.tier &&
                        (this.selectedVersion.backupTiers[i].state === 'DONE' ||
                            this.selectedVersion.backupTiers[i].state === 'DONE_WITH_ERRORS')
                );
                if (filteredTiers.length) {
                    this.setValues(filteredTiers[0], i + 1);
                }
            }

            this.tier = this.recoverOptions[0];
            this.changeState(PICK_STATE);
        }
        this.setHelpId();
        this.load(this.firstLoad);
    }

    onBackAction() {
        if (this.state === PICK_STATE) {
            if (this.isDisksPickState()) {
                this.changeState(DISK_SELECT_STATE);
                this.load(false);
            } else {
                this.changeState(OPTIONS_STATE);
                this.firstLoad = true;
                this.clearListeners();
            }
            this.isRestoreValid = false;
            this.recoverOptions = [];
            this.newDisksNames = null;
        } else if (this.state === DISK_SELECT_STATE) {
            this.changeState(OPTIONS_STATE);
            this.isRestoreValid = false;
            this.firstLoad = true;
            this.clearListeners();
            this.newDisksNames = null;
        } else {
            this.changeState(PICK_STATE);
            this.isRestoreValid = false;
            this.$timeout(() => {
                document.getElementById('newvmName').focus();
            }, 0);
        }
        this.setHelpId();
    }

    isDisksPickState() {
        return (
            this.pick === RESTORE_DISK_PICK_STATE ||
            this.pick === CLONE_DISK_PICK_STATE ||
            this.pick === EXPORT_DISK_PICK_STATE
        );
    }

    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            this.changeStateAction(state);
        }
    }

    changeStateAction(state) {
        if (state === OPTIONS_STATE) {
            this.modalTitle = VERSION_TITLE;
            this.modalSubTitle = null;
        } else if (state === DISK_SELECT_STATE) {
            if (this.pick === CLONE_DISK_PICK_STATE) {
                this.modalTitle = VERSION_TITLE;
                this.modalSubTitle =
                    ' » ' + this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskClone.title');
            } else if (this.pick === RESTORE_DISK_PICK_STATE) {
                this.modalTitle = VERSION_TITLE;
                this.modalSubTitle =
                    ' » ' + this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskRestore.title');
            } else if (this.pick === EXPORT_DISK_PICK_STATE) {
                this.modalTitle = VERSION_TITLE;
                this.modalSubTitle =
                    ' » ' + this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskExport.title');
            }
        } else {
            if (state === PICK_STATE) {
                if (this.isDisksPickState()) {
                    if (this.pick === CLONE_DISK_PICK_STATE) {
                        this.modalTitle = VERSION_TITLE;
                        this.modalSubTitle =
                            ' » ' +
                            this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskClone.title');
                    } else if (this.pick === RESTORE_DISK_PICK_STATE) {
                        this.modalTitle = VERSION_TITLE;
                        this.modalSubTitle =
                            ' » ' +
                            this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskRestore.title');
                    } else if (this.pick === EXPORT_DISK_PICK_STATE) {
                        this.modalTitle = VERSION_TITLE;
                        this.modalSubTitle =
                            ' » ' +
                            this.$filter('translate')('vm.restore.options.restoreVirtualMachine.diskExport.title');
                    }
                } else {
                    this.modalTitle = VERSION_TITLE;
                    this.modalSubTitle = ' » ' + (this.pick === CLONE_VM_PICK_STATE ? 'Clone VM' : 'Restore VM');
                }
            }
        }
        this.state = state;
    }

    setCarousel(carousel) {
        this.carousel = carousel;
    }

    onTitleClick() {
        this.showOptionsState();
    }

    showOptionsState() {
        this.state = OPTIONS_STATE;
        this.modalSubTitle = null;
    }

    showVirtualNetworksState() {
        this.state = NETWORK_STATE;
    }

    showPickState() {
        this.state = PICK_STATE;
        this.modalTitle = VERSION_TITLE;
        this.modalSubTitle = ' » ' + (this.pick === CLONE_VM_PICK_STATE ? 'Clone VM' : 'Restore VM');
    }

    editDiskName(diskName, diskIndex) {
        this.showNewDiskNameModal = true;
        this.selectedDiskToRename = diskName;
        this.diskIndex = diskIndex;
    }

    undoNewDiskName(diskIndex) {
        this.newDisksNames[diskIndex].value = this.selectedDisksForRestore[diskIndex].value;
    }

    changeDiskName(newDiskName, index) {
        if (!this.newDisksNames) {
            this.newDisksNamesArray();
        }
        this.newDisksNames[index].value = newDiskName;
    }

    newDisksNamesArray() {
        if (this.selectedDisksForRestore && this.selectedDisksForRestore.length > 0) {
            this.newDisksNames = this.selectedDisksForRestore.map((disk) => {
                return { value: disk.value };
            });
        }
    }

    prepareNewDiskNames() {
        if (this.newDisksNames && this.newDisksNames.length > 0) {
            return this.newDisksNames.map((disk, index) => {
                if (disk.value === this.selectedDisksForRestore[index].value) {
                    return '';
                }
                return disk.value;
            });
        }
        return null;
    }

    onOpen() {
        this.firstLoad = true;
        this.showOptionsState();
        this.virtualNetworks = [];
        this.recoverOptions = [];
        this.subscription = '';
        this.location = '';
        this.resourceGroup = '';
        this.zone = '';
        this.subnets = [];
        this.virtualNetwork = '';
        this.availabilityZone = '';
        this.osType = this.selectedVm.operatingSystem.indexOf('LINUX') !== -1 ? 'LINUX' : 'WINDOWS';
        this.persistence.getVmNetwork(this.selectedVm.uuid).then((response) => {
            if (response.length !== 0) {
                this.virtualNetworks.push({
                    group: 'Virtual Network',
                    // type: this.$filter('translate')('vm.restore.options.network.interface'),
                    label: response[0].name + ' (' + response[0].subnets[0] + ')',
                    value: response[0],
                });
            }
        });
        this.disksForRestore = [...this.selectedVersion.disks];
        this.disksForRestore.forEach((d, i) => {
            d.backupTiers = d.backupTiers.map((itemD) => {
                itemD = itemD.value ? itemD.value : itemD;
                return {
                    value: itemD,
                    label: this.$filter('translate')('vm.subTable.detail.tagInfo.' + itemD.toLowerCase()),
                    smallLabel: this.$filter('translate')('vm.subTable.detail.tagInfo.small.' + itemD.toLowerCase()),
                    class: itemD.indexOf('ARCH') > -1 ? 'arch' : itemD.toLowerCase(),
                    tooltip: this.$filter('translate')('vm.subTable.detail.tagInfo.tooltip.' + itemD.toLowerCase()),
                };
            });
            d.value = d.name;
            d.restorePointUuid = d.uuid;
            d.uuid = i;
            this.maxNumTags = d.backupTiers.length > this.maxNumTags ? d.backupTiers.length : this.maxNumTags;
        });
        this.isBootDiskPresent = this.disksForRestore.filter((d) => d.os).length > 0;
        this.pickCloneVirtualMachine[0].isDisabled = !this.isBootDiskPresent;
        this.pickCloneVirtualMachine[1].isDisabled = !this.isBootDiskPresent;

        this.pick = this.isBootDiskPresent ? PARTIAL_RESTORE_PICK_STATE : RESTORE_DISK_PICK_STATE;
        this.$timeout(() => {
            this.carouselIsVisible = true;
        }, 300);
    }

    setValues(tier, index) {
        this.recoverOptions.push({
            id: index,
            label: tier.label,
            value: tier.tier,
            selected: true,
        });
    }

    searchRg() {
        this.offsetRgs = this.availableResourceGroups.filter(
            (rg) => rg.label.toLowerCase().indexOf(this.rgSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchLocation() {
        this.offsetLocations = this.availableLocations.filter(
            (location) => location.label.toLowerCase().indexOf(this.locationSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchAvailabilityZone() {
        this.availabilityZones = this.allAvailabilityZone.filter(
            (location) =>
                location.label.toLowerCase().indexOf(this.availabilityZoneSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchVm() {
        this.displayedVMs = this.allVMs.filter(
            (vm) => vm.label.toLowerCase().indexOf(this.vmSearch.searchBy.toLowerCase()) !== -1
        );
    }

    searchSub() {
        this.offsetSubs = this.availableSubscriptions.filter(
            (subscription) => subscription.label.toLowerCase().indexOf(this.subSearch.searchBy.toLowerCase()) !== -1
        );
    }

    load(firstLoad) {
        this.availableDisks = this.setOptions('disks', this.selectedVersion.disks);
        this.availableDisks.forEach((disk) => {
            disk.disabled = disk.os ? true : false;
            disk.selected = true;
            this.disks.push(disk);
        });
        if (firstLoad) {
            if (
                this.pick === CLONE_VM_PICK_STATE ||
                this.pick === CLONE_DISK_PICK_STATE ||
                this.pick === EXPORT_DISK_PICK_STATE
            ) {
                this.busy = true;
                Promise.all([
                    this.persistence.getSubscription(),
                    this.persistence.getResourceGroupsFromAzure(null, this.selectedVm.subscriptionUuid),
                    this.persistence.getLocations(null, this.selectedVm.subscriptionUuid),
                ]).then((data) => {
                    this.availableResourceGroups = data[1];
                    this.offsetRgs = data[1];
                    this.resourceGroup = this.availableResourceGroups.filter(
                        (rg) => rg.label === this.selectedVm.resourceGroup
                    )[0];
                    this.osType = this.selectedVm.operatingSystem.indexOf('LINUX') !== -1 ? 'LINUX' : 'WINDOWS';
                    if (this.pick === CLONE_DISK_PICK_STATE) {
                        Promise.all([
                            this.persistence.getVirtualMachinesForDiskRestore(
                                null,
                                this.selectedVm.subscriptionUuid,
                                this.resourceGroup,
                                this.selectedVm.location.uuid,
                                this.osType
                            ),
                        ]).then((vmData) => {
                            this.allVMs = [];
                            this.displayedVMs = [];
                            this.allVMs = vmData[0].map((vm) => {
                                return {
                                    label: vm.name,
                                    value: vm.uuid,
                                };
                            });
                            this.displayedVMs = this.allVMs.slice();
                            this.VMSearch = {};

                            this.availableLocations = data[2].map((location) => {
                                return {
                                    uuid: location.uuid,
                                    label: location.displayName,
                                    value: location.name,
                                };
                            });
                            this.offsetLocations = this.availableLocations;

                            this.availableSubscriptions = data[0].map((sub) => {
                                return {
                                    value: sub.uuid,
                                    label: sub.name,
                                    managerEndpointUrl: sub.managerEndpointUrl,
                                };
                            });
                            this.offsetSubs = this.availableSubscriptions;
                            this.location = this.availableLocations.filter(
                                (rg) => rg.label === this.selectedVm.location.displayName
                            )[0];
                            this.subscription = this.availableSubscriptions.filter(
                                (pr) => pr.value === this.selectedVm.subscriptionUuid
                            )[0];
                            this.virtualMachine = this.displayedVMs[0];
                            this.firstLoad = false;
                            this.busy = false;
                            this.setListeners();
                        });
                    } else {
                        Promise.all([
                            this.persistence.getVirtualNetworks(
                                null,
                                this.selectedVm.subscriptionUuid,
                                this.selectedVm.location.name
                            ),
                            this.persistence.getAvailabilityZone(
                                null,
                                this.selectedVm.subscriptionUuid,
                                this.selectedVm.location.uuid,
                                this.selectedVm.size.uuid
                            ),
                        ]).then((vnData) => {
                            let virtualNetworks = vnData[0];
                            vnData[1].splice(0, 0, 'None');
                            this.allAvailabilityZone = vnData[1].map((zones) => {
                                return {
                                    uuid: zones,
                                    label: zones,
                                    value: zones,
                                };
                            });
                            this.availabilityZones = this.allAvailabilityZone.slice();
                            this.availabilityZone = this.availabilityZones[0];
                            this.setVirtualNetworks(virtualNetworks);
                            this.availableLocations = data[2].map((location) => {
                                return {
                                    uuid: location.uuid,
                                    label: location.displayName,
                                    value: location.name,
                                };
                            });
                            this.offsetLocations = this.availableLocations;

                            this.availableSubscriptions = data[0].map((sub) => {
                                return {
                                    value: sub.uuid,
                                    label: sub.name,
                                    managerEndpointUrl: sub.managerEndpointUrl,
                                };
                            });
                            this.offsetSubs = this.availableSubscriptions;

                            this.osType = this.selectedVm.operatingSystem.indexOf('LINUX') !== -1 ? 'LINUX' : 'WINDOWS';
                            this.maxVmNameLength = this.osType === 'LINUX' ? 64 : 15;
                            this.location = this.availableLocations.filter(
                                (rg) => rg.label === this.selectedVm.location.displayName
                            )[0];

                            this.subscription = this.availableSubscriptions.filter(
                                (pr) => pr.value === this.selectedVm.subscriptionUuid
                            )[0];
                            this.firstLoad = false;
                            this.busy = false;
                            this.setListeners();
                            document.getElementById('available-disks').focus();
                            if (this.pick !== EXPORT_DISK_PICK_STATE) {
                                document.getElementById('newvmName').focus();
                            }
                        });
                    }
                });
            }
        }
    }

    editDiskAction(disk) {
        this.editingDiskName = disk.name;
        this.editedDisk = null;
        this.editedDisk = _.cloneDeep(this.selectedDisksForRestore.filter((cd) => cd.name === this.editingDiskName)[0]);
    }

    openVirtualNetworkDialog(editMode, entry) {
        this.virtualNetworkEditFlag = false;
        this.setAvailableNetworks(editMode, entry);

        if (!editMode) {
            this.showAzureNetworkModal = true;
        }
    }

    setAvailableNetworks(editMode, entry) {
        this.virtualNetwork = null;
        if (!this.virtualNetworks.length) {
            this.allVirtualNetworks.forEach((net) => {
                net.subnetsList.forEach((i) => (i.isAdded = false));
            });
            this.availableVirtualNetworks = this.allVirtualNetworks;
            return;
        }
        // Note: Azure VMs can only be connected to 1 virtual network
        // User can set list with different subnets, but network must be the same
        this.availableVirtualNetworks = this.allVirtualNetworks.filter(
            (n) => n.value === this.virtualNetworks[0].parentValue
        );
    }

    removeNetwork(entry) {
        return this.dialogService
            .showYesNo(
                this.$filter('translate')('ec.deploy.network.delete.message'),
                this.$filter('translate')('ec.deploy.network.delete.title')
            )
            .then((res) => {
                if (res) {
                    this.virtualNetworks = this.virtualNetworks.filter((item) => {
                        return entry.id !== item.id;
                    });
                    // this.updateAllNetwork(entry.parentValue);
                }
            });
    }

    removeEntry(entry) {
        this.virtualNetworks = this.virtualNetworks.filter((item) => {
            return entry.subnetKey
                ? item.subnetKey.subnetName !== entry.subnetKey.subnetName ||
                item.subnetKey.subscriptionId !== entry.subnetKey.subscriptionId
                : item.virtualNetworkName !== entry.virtualNetworkName;
        });
    }

    editNetwork(entry) {
        this.openVirtualNetworkDialog(true, entry);
        this.virtualNetworkEditFlag = true;
        this.virtualNetwork = entry;
        this.showAzureNetworkModal = true;
    }

    saveVirtualNetwork() {
        this.virtualNetworkStateFlag = false;
        this.isRestoreValid = false;
        if (this.virtualNetwork.value) {
            this.virtualNetwork.value.publicIp = this.externalIp;
        } else {
            this.virtualNetwork.publicIp = this.externalIp;
        }
        if (!this.virtualNetworkEditFlag) {
            this.virtualNetworks.push({
                label: this.virtualNetwork.name + ' (' + this.virtualNetwork.subnets[0] + ')',
                value: this.virtualNetwork,
            });
        }
        this.interfaec = null;
        this.changeState(PICK_STATE);
    }

    setOptions(id, res) {
        return res.map((elem, i) => ({
            id: id + i,
            label: typeof elem === 'string' ? elem : elem.name,
            value: typeof elem === 'string' ? elem : elem.name,
            managerUrl: elem.managerUrl,
            os: elem.os,
        }));
    }

    getRestoreType() {
        let restoreType = '';
        switch (this.pick) {
            case CLONE_VM_PICK_STATE:
                restoreType = 'CLONE';
                break;
            case PARTIAL_RESTORE_PICK_STATE:
                restoreType = 'PARTIAL';
                break;
            case RESTORE_DISK_PICK_STATE:
                restoreType = 'DISK_RESTORE';
                break;
            case CLONE_DISK_PICK_STATE:
                restoreType = 'DISK_CLONE';
                break;
            case EXPORT_DISK_PICK_STATE:
                restoreType = 'DISK_EXPORT';
                break;
        }

        return restoreType;
    }

    setRestoreData() {
        let diskNames = [];
        (this.isDisksPickState() ? this.selectedDisksForRestore : this.disks || []).forEach((disk) => {
            diskNames.push(disk.value);
        });
        let data = {
            restoreType: this.getRestoreType(),
            restoreSource: {
                restorePointUuid: this.selectedVersion.uuid,
                tier: this.tier.value,
                diskNames: diskNames,
            },
        };
        if (this.pick === CLONE_VM_PICK_STATE) {
            data.restoreTarget = {
                subscriptionUuid: this.subscription.value,
                virtualMachineName: this.newvmName,
                zone: this.zone.value,
                location: {
                    uuid: this.location.uuid,
                    displayName: this.location.label,
                    name: this.location.value,
                },
                resourceGroup: this.resourceGroup.label,
                zones: !this.availabilityZone
                    ? undefined
                    : this.availabilityZone.value === 'None'
                        ? []
                        : [this.availabilityZone.value],
            };
            if (this.virtualNetworks.length > 0) {
                data.restoreTarget.virtualNetwork = {
                    name: this.virtualNetworks[0].parentValue,
                    subscriptionUuid: this.virtualNetworks[0].subscriptionUuid,
                    resourceGroup: this.virtualNetworks[0].resourceGroup,
                    location: this.virtualNetworks[0].location,
                    networkInterfaces: this.virtualNetworks.map((network) => {
                        return {
                            subnetName: network.value,
                            ipConfiguration: network.ipConfiguration,
                        };
                    }),
                };
            } else {
                data.restoreTarget.subnets = [];
                this.virtualNetworks.forEach((item) => {
                    data.restoreTarget.subnets.push(item.value);
                });
            }
        } else if (this.pick === CLONE_DISK_PICK_STATE || this.pick === EXPORT_DISK_PICK_STATE) {
            const newDisksNames = this.prepareNewDiskNames();
            data.restoreTarget = {
                subscriptionUuid: this.subscription.value,
                zone: this.zone.value,
                location: {
                    uuid: this.location.uuid,
                    displayName: this.location.label,
                    name: this.location.value,
                },
                newDisksNames:
                    newDisksNames && newDisksNames.length > 0 && !newDisksNames.every((item) => item === '')
                        ? newDisksNames
                        : null,
                resourceGroup: this.resourceGroup.label,
                zones:
                    !this.availabilityZone || this.pick === CLONE_DISK_PICK_STATE
                        ? undefined
                        : this.availabilityZone.value === 'None'
                            ? []
                            : [this.availabilityZone.value],
            };
            if (this.pick === CLONE_DISK_PICK_STATE) {
                data.restoreTarget.virtualMachineUuid = this.virtualMachine.value;
            }
        }
        return data;
    }

    validateRestore() {
        let data = this.setRestoreData();
        this.busy = true;
        this.persistence
            .validateRestore(data)
            .then((resp) => {
                resp.statusCode === 200 || resp.statusCode === 201 ? (this.isRestoreValid = true) : false;
                if (resp.message) this.notificationService.pop(resp.message);
            })
            .finally(() => (this.busy = false));
    }

    restore() {
        let data = this.setRestoreData();
        this.busy = true;
        this.persistence
            .restore(data)
            .then((resp) => {
                this.postAction();
                if (resp.message) this.notificationService.pop(resp.message);
            })
            .finally(() => (this.busy = false));
    }

    postAction() {
        this.$timeout(() => {
            this.virtualMachineCtrl
                .refreshBackups(false)
                .then((restorePoints) => {
                    this.virtualMachineCtrl.restorePoints = restorePoints;
                })
                .finally(() => (this.busy = false));
            this.virtualMachineCtrl.refreshVirtualMachines(true);
        }, 3000);
        this.showModal = false;
    }

    setListeners() {
        /* this.subscriptionListener = this.$scope.$watch(
            () => this.subscription,
            (newVal, oldVal) => {
                if (newVal !== oldVal) {
                    console.log('run');
                    this.zone = '';
                    this.subnets = [];
                    this.virtualNetworks = [];
                    this.location = '';
                    this.resourceGroup = '';
                    this.availableZones = [];
                    this.allVirtualNetworks = [];
                    this.isRestoreValid = false;
                    this.persistence
                        .getResourceGroupsFromAzure(this.subscription.managerUrl, this.subscription.value)
                        .then((res) => {
                            this.availableResourceGroups = res;
                        });
                    this.resourceGroup = this.availableResourceGroups
                        ? this.availableResourceGroups.filter((rg) => rg.label === this.selectedVm.resourceGroup)[0]
                        : [];
                    this.persistence.getLocations(this.subscription.managerUrl, this.subscription.value).then((res) => {
                        this.availableLocations = res.map((location) => {
                            return {
                                uuid: location.uuid,
                                label: location.displayName,
                                value: location.name,
                            };
                        });
                        this.location = this.availableLocations.filter(
                            (rg) => rg.label === this.selectedVm.location.displayName
                        )[0];

                        if (this.pick === CLONE_DISK_PICK_STATE) {
                            this.persistence
                                .getVirtualMachinesForDiskRestore(
                                    null,
                                    this.subscription.value,
                                    this.resourceGroup,
                                    this.location.uuid,
                                    this.osType
                                )
                                .then((res) => {
                                    this.allVMs = [];
                                    this.displayedVMs = [];
                                    this.allVMs = res.map((vm) => {
                                        return {
                                            label: vm.name,
                                            value: vm.uuid,
                                        };
                                    });
                                    this.displayedVMs = this.allVMs.slice();
                                    this.virtualMachine = this.displayedVMs[0];
                                    this.VMSearch = {};
                                    this.busy = false;
                                });
                        }
                    });
                    if (this.pick === CLONE_DISK_PICK_STATE) {
                        this.persistence
                            .getVirtualNetworks(this.subscription.managerEndpointUrl, this.subscription.value)
                            .then((res) => {
                                this.setVirtualNetworks(res);
                            });
                    }
                }
            }
        ); */

        this.resourceGroupListener = this.$scope.$watch(
            () => this.resourceGroup,
            (newVal, oldVal) => {
                if (newVal != oldVal && newVal) {
                    this.isRestoreValid = false;
                    this.busy = true;
                    this.subnets = [];
                    this.allVirtualNetworks = [];
                    this.persistence.getLocations(this.subscription.managerUrl, this.subscription.value).then((res) => {
                        this.availableLocations = res.map((location) => {
                            return {
                                uuid: location.uuid,
                                label: location.displayName,
                                value: location.name,
                            };
                        });

                        if (this.pick === CLONE_DISK_PICK_STATE && this.subscription !== '') {
                            this.persistence
                                .getVirtualMachinesForDiskRestore(
                                    null,
                                    this.subscription.value,
                                    this.resourceGroup,
                                    this.location.uuid,
                                    this.osType
                                )
                                .then((res) => {
                                    this.allVMs = [];
                                    this.displayedVMs = [];
                                    this.allVMs = res.map((vm) => {
                                        return {
                                            label: vm.name,
                                            value: vm.uuid,
                                        };
                                    });
                                    this.displayedVMs = this.allVMs.slice();
                                    this.virtualMachine = this.displayedVMs[0];
                                    this.VMSearch = {};
                                    this.busy = false;
                                });
                        } else {
                            this.busy = false;
                        }
                    });
                    if (this.pick === CLONE_VM_PICK_STATE) {
                        this.busy = true;

                        this.persistence
                            .getVirtualNetworks(
                                this.subscription.managerUrl,
                                this.subscription.value,
                                this.location.value
                            )
                            .then((res) => {
                                this.setVirtualNetworks(res);
                                this.busy = false;
                            });
                    }
                }
            }
        );

        this.locationListener = this.$scope.$watch(
            () => this.location,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                    this.busy = true;
                    this.zone = '';
                    this.subnets = [];
                    this.virtualNetworks = [];

                    if (this.pick === CLONE_DISK_PICK_STATE) {
                        this.persistence
                            .getVirtualMachinesForDiskRestore(
                                null,
                                this.subscription.value,
                                this.resourceGroup,
                                this.location.uuid,
                                this.osType
                            )
                            .then((res) => {
                                this.allVMs = [];
                                this.displayedVMs = [];
                                this.allVMs = res.map((vm) => {
                                    return {
                                        label: vm.name,
                                        value: vm.uuid,
                                    };
                                });
                                this.displayedVMs = this.allVMs.slice();
                                this.virtualMachine = this.displayedVMs[0];
                                this.VMSearch = {};
                                this.busy = false;
                            });
                    } else if (this.pick === CLONE_VM_PICK_STATE || this.pick === EXPORT_DISK_PICK_STATE) {
                        let promises = [
                            this.persistence.getAvailabilityZone(
                                this.subscription.managerUrl,
                                this.subscription.value,
                                this.location.uuid,
                                this.selectedVm.size.uuid
                            ),
                        ];
                        if (this.pick === CLONE_VM_PICK_STATE) {
                            this.allVirtualNetworks = this.allVirtualNetworks.filter((item) => item.value);
                            promises.push(
                                this.persistence.getVirtualNetworks(
                                    this.subscription.managerUrl,
                                    this.subscription.value,
                                    this.location.value
                                )
                            );
                        }
                        Promise.all(promises).then((data) => {
                            if (this.pick === CLONE_VM_PICK_STATE) this.setVirtualNetworks(data[1]);
                            data[0].splice(0, 0, 'None');
                            this.allAvailabilityZone = data[0].map((zones) => {
                                return {
                                    uuid: zones,
                                    label: zones,
                                    value: zones,
                                };
                            });
                            this.availabilityZones = this.allAvailabilityZone.slice();
                            this.availabilityZone = this.availabilityZones[0];
                            this.busy = false;
                        });
                    } else {
                        this.busy = false;
                    }
                }
            }
        );

        this.disksListener = this.$scope.$watch(
            () => this.disks,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );

        this.tierListener = this.$scope.$watch(
            () => this.tier,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );

        this.vmNameListener = this.$scope.$watch(
            () => this.newvmName,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );

        this.tagsUnwatch = this.$scope.$watch(
            () => this.$element.find('.backup-tiers-tags').width(),
            (width) => {
                this.oneLetter = width && width < this.maxNumTags * 50 + 50;
            }
        );
    }

    setVirtualNetworks(res) {
        this.virtualNetworks = [];
        this.allVirtualNetworks = [];
        this.allVirtualNetworks = res.map((item) => {
            item.label = item.name;
            item.value = item.name;
            item.isParent = true;
            item.subnetsList = item.subnets.map((i, index) => {
                return {
                    subnetId: index,
                    label: i,
                    value: i,
                    parentValue: item.value,
                    isChild: true,
                    isAdded: false,
                    resourceGroup: item.resourceGroup,
                    subscriptionUuid: item.subscriptionUuid,
                    location: item.location,
                };
            });
            return item;
        });

        if (
            !this.allVirtualNetworks[0] ||
            !this.allVirtualNetworks[0].subnetsList ||
            !this.allVirtualNetworks[0].subnetsList.length
        ) {
            return;
        }

        if (this.allVirtualNetworks.filter((network) => network.resourceGroup === this.resourceGroup.label)[0]) {
            let firstItem = this.allVirtualNetworks.filter(
                (network) => network.resourceGroup === this.resourceGroup.label
            )[0].subnetsList[0];
            if (firstItem) {
                firstItem.isAdded = true;
                this.virtualNetworks.push({
                    id: this.virtualNetworks.length,
                    subnetId: firstItem.subnetId,
                    value: firstItem.value,
                    parentValue: firstItem.parentValue,
                    resourceGroup: firstItem.resourceGroup,
                    subscriptionUuid: firstItem.subscriptionUuid,
                    location: firstItem.location,
                    ipConfiguration: {
                        privateIpRange: null,
                        privateIpType: 'DYNAMIC',
                        publicIp: null,
                        publicIpType: 'NONE',
                    },
                });
            }
        }
    }

    addNetwork(publicIpType, publicIp, privateIpType, privateIpRange, subnet) {
        return this.$q((resolve) => {
            this.$timeout(() => {
                this.addNetworkToList(
                    publicIpType,
                    publicIp,
                    privateIpType,
                    privateIpRange,
                    subnet,
                    this.virtualNetworkEditFlag
                );
                resolve();
            }, 500);
        });
    }

    addNetworkToList(publicIpType, publicIp, privateIpType, privateIpRange, subnet, editMode) {
        if (!editMode) {
            this.virtualNetworks.push({
                id: this.virtualNetworks.length,
                subnetId: subnet.subnetId,
                value: subnet.value,
                parentValue: subnet.parentValue,
                resourceGroup: subnet.resourceGroup,
                subscriptionUuid: subnet.subscriptionUuid,
                location: subnet.location,
                subnetName: subnet.value,
                ipConfiguration: {
                    publicIpType: publicIpType,
                    publicIp: publicIp
                        ? {
                            subscriptionUuid: publicIp.subscriptionUuid,
                            resourceGroup: publicIp.resourceGroup,
                            name: publicIp.value,
                        }
                        : null,
                    privateIpType: privateIpType,
                    privateIpRange: privateIpRange,
                },
            });
        } else {
            this.virtualNetworks.forEach((net) => {
                if (net.subnetId !== this.virtualNetwork.subnetId) return;
                net.id = net.id;
                net.subnetId = subnet.subnetId;
                net.value = subnet.value;
                net.parentValue = subnet.parentValue;
                net.resourceGroup = subnet.resourceGroup;
                net.subscriptionUuid = subnet.subscriptionUuid;
                net.location = subnet.location;
                net.subnetName = subnet.value;
                let ipConfigObj = {
                    publicIpType: publicIpType,
                    publicIp: publicIp
                        ? {
                            subscriptionUuid: publicIp.subscriptionUuid,
                            resourceGroup: publicIp.resourceGroup,
                            name: publicIp.value,
                        }
                        : null,
                    privateIpType: privateIpType,
                    privateIpRange: privateIpRange,
                };
                net.ipConfiguration = ipConfigObj;
            });
        }
        this.virtualNetwork = null;
        // this.updateAllNetwork(subnet.parentValue);
    }

    getExternalAddresses(subscription) {
        return this.persistence.getExternalAddresses(subscription, this.location.value, this.availabilityZone.value);
    }

    isNextDisabled() {
        return (
            (this.state === DISK_SELECT_STATE &&
                this.isDisksPickState() &&
                this.selectedDisksForRestore.length === 0) ||
            this.busy
        );
    }

    setGrid(grid) {
        this.grid = grid;
        this.gridColumnsStyleConfig = {
            multiselect: true,
            columnsWidthMapInPct: [],
        };
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('5%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('30%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('45%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('10%');
        this.gridColumnsStyleConfig.columnsWidthMapInPct.push('10%');
        this.gridFlag = true;
    }

    copyToClipboard(uuid, event) {
        //creat temporary div, because copyToClipboard require html element
        event.stopPropagation();
        let div = document.createElement('div');
        div.id = 'temp-element';
        div.innerHTML = uuid;
        document.getElementById('single-disk').appendChild(div);

        this.utilsService.copyToClipboard('temp-element', 'ID');

        document.getElementById('single-disk').removeChild(div);
    }

    configTable() {
        this.columnNames = [
            this.$filter('translate')('vm.restore.options.diskState.diskName'),
            this.$filter('translate')('vm.restore.options.diskState.tiers'),
            this.$filter('translate')('vm.restore.options.diskState.size'),
            'ID',
        ];
    }

    clearListeners() {
        if (this.subscriptionListener) this.subscriptionListener();
        if (this.locationListener) this.locationListener();
        if (this.resourceGroupListener) this.resourceGroupListener();
        if (this.tagsUnwatch) this.tagsUnwatch();
        if (this.disksListener) this.disksListener();
        if (this.tierListener) this.tierListener();
        if (this.vmNameListener) this.vmNameListener();
    }

    onClose() {
        this.clearListeners();
        this.$timeout(() => {
            this.carouselIsVisible = false;
            this.initValues();
            this.disks = [];
            this.subscription = '';
            this.location = '';
            this.resourceGroup = '';
            this.zone = '';
            this.subnets = [];
            this.virtualNetwork = '';
            this.disksForRestore = [];
            this.selectedDisksForRestore = [];
            this.enableLegacyVirtualNetwork = false;
            this.isRestoreValid = false;
            this.newDisksNames = null;
        }, 0);
    }
}

RecoverVmController.$inject = [
    '$scope',
    '$timeout',
    '$q',
    '$element',
    '$filter',
    'virtualMachinesPersistence',
    'notificationService',
    'utilsService',
    'dialogService',
    'sharedPersistenceService',
    'contentSwitcherService',
    'validationsService',
];

const recoverVmComponent = {
    controller: RecoverVmController,
    require: {
        virtualMachineCtrl: '^^virtualMachines',
    },
    template: require('./recoverVm.template.html'),
    bindings: {
        showModal: '=',
        onClosed: '&onClose',
        selectedVersion: '=',
        selectedVm: '=',
    },
};

module.exports = recoverVmComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/recoverVm/recoverVm.component.js